export default "__VITE_ASSET__c0c5f2e7__"